import { Modal, Form, Row, Col } from 'react-bootstrap'
import { useState } from 'react'
import * as Common from '../../../utils/Common'
import { Formik } from 'formik'
import api from '../../../config/AxiosInstance'
import { BusinessUnitAddEditSchema } from '../../../utils/validationSchema'
import CustomButton from '../../Button/CustomButton'
import CustomCloseButton from '../../Button/CustomCloseButton'
import TextField from '../../Input/TextInput'
import SelectInput from '../../Input/SelectInput'

const statuses = [
  { id: 'true', name: 'Active' },
  { id: 'false', name: 'Inactive' }
]

const FormControlStyle = {
  height: '45px',
  borderRadius: '10px',
  border: '1px solid #e9ecef',
  backgroundColor: '#ffffff',
  fontSize: '0.9rem'
}

function ModalAddBusinessUnit(props) {
  const [loadingSubmit, setLoadingSubmit] = useState(false)

  const handleSubmit = async (values) => {
    try {
      setLoadingSubmit(true)
      const payload = {
        name: values.name,
        status: values.status === 'true' || values.status === true
      }
      const response = await api.post('/master/business-units/add', payload)
      if (response.data.success) {
        props.onHide()
        props.refreshData()
        Common.showPopUpSuccessMessage(response.data.message)
      }
    } catch (err) {
      const errMsg = err?.response?.data?.errors?.message || 'An error occurred'
      Common.showPopUpErrorMessage(errMsg)
    } finally {
      setLoadingSubmit(false)
    }
  }

  return (
    <Modal {...props} centered>
      <Modal.Header closeButton>
        <Modal.Title>Add Business Unit</Modal.Title>
      </Modal.Header>
      <Modal.Body>
        <Formik
          initialValues={{
            name: '',
            status: 'true'
          }}
          validationSchema={BusinessUnitAddEditSchema}
          validateOnChange={true}
          validateOnBlur={true}
          onSubmit={(values) => {
            handleSubmit(values)
          }}
        >
          {({
            handleBlur,
            handleSubmit,
            handleChange,
            values,
            errors,
            touched,
            isValid,
            dirty
          }) => {
            return (
              <Form className="d-grid gap-2" onSubmit={handleSubmit}>
                <Row>
                  <Col md={12}>
                    <TextField
                      label="Business Unit Name"
                      name="name"
                      value={values.name}
                      handleChange={handleChange}
                      handleBlur={handleBlur}
                      touched={touched}
                      errors={errors}
                      placeholder="Input Business Unit Name"
                      required={true}
                      styles={FormControlStyle}
                    />
                  </Col>
                  <Col md={12}>
                    <SelectInput
                      label="Status"
                      name="status"
                      id="status"
                      value={values.status}
                      handleChange={handleChange}
                      handleBlur={handleBlur}
                      touched={touched}
                      errors={errors}
                      options={statuses}
                      required={true}
                      styles={FormControlStyle}
                    />
                  </Col>
                </Row>
                <Modal.Footer className="mt-3">
                  <CustomCloseButton text={'Cancel'} onClick={props.onHide} />
                  <CustomButton
                    onClick={handleSubmit}
                    variant={
                      !isValid || !dirty || loadingSubmit
                        ? 'secondary'
                        : 'primary'
                    }
                    disabled={!isValid || !dirty || loadingSubmit}
                    text={loadingSubmit ? 'Saving...' : 'Save'}
                  />
                </Modal.Footer>
              </Form>
            )
          }}
        </Formik>
      </Modal.Body>
    </Modal>
  )
}

export default ModalAddBusinessUnit
